/*
 * rootSaga
 */

import { all, call, put, fork } from 'redux-saga/effects';
import { SET_LOADER } from '../components/App/store/actions';
import store from './configureStore';
import Utils from 'utils/utils';
import * as Sentry from '@sentry/react';

import {
  watchGetConsignersSaga,
  watchCreateConsignerSaga,
  watchFetchConsignerDetailsSaga,
  watchEditBasicDetailsSaga,
  watchEditVpaDetailsSaga,
  watchCreateVpaDetailsSaga,
  watchSaveEditedAddressSaga,
  watchCreateNewAddressSaga,
  watchSaveConsignerGstSaga,
  watchCreateConsignerGstSaga,
  watchDeletePocSaga,
  watchDeleteAddressSaga,
  watchDeleteGstSaga,
  watchUploadDocumentSaga,
  watchViewFileSaga,
  watchGetUploadGstUrl,
  watchViewGstUrlSaga,
  watchGetConsignerTypeSaga,
  watchGetConsignerStatusSaga,
  watchEditCompliancesSaga,
  watchUploadConsignerFileSaga,
  watchViewConsignerFileSaga,
  watchGetVpaDetailsSaga,
  watchGetSearchResultsSaga,
  watchEditPaymentSaga,
  watchEditBusinesstSaga,
  watchEditNotificationSaga,
  fetchConsignerDetails,
  watchGetImageUrlSaga1,
} from '../components/Consigner/store/sagas';

import {
  watchGetThirdPartyListSaga,
  watchCreateAccountSaga,
  watchEditAccountSaga,
  watchDisableEditSaga,
  watchVerifyThirdPartyAccountOtpSaga,
  watchResendThirdPartyAccountOtpSaga,
} from '../components/ThirdParty/store/sagas';

import {
  watchGetOperatorsListSaga,
  watchGetOperatorByIdSaga,
  watchGetKycStatusHistorySaga,
  watchGetBasicDetailsOperatorSaga,
  watchGetAddressDetailsOperatorSaga,
  watchViewUploadedDocumentSaga,
  watchGetCompliancesDetailsOperatorSaga,
  watchGetDocumentDetailsOperatorSaga,
  watchGetVehicleDetailsOperatorSaga,
  watchSendUndertakingLinkSaga,
  watchSendTdsLinkSaga,
  watchUpdateOperatorBasicDetailsSaga,
  watchUpdateOperatorAddressDetailsSaga,
  watchUpdateOperatorComplaincesDetailsSaga,
  watchUpdateOperatorVehiclesDetailsSaga,
  watchUploadOperatorIdentityDocumentSaga,
  watchUpdateOperatorDocumentDetailsSaga,
  watchUpdateOperatorTdsDetailsSaga,
  watchUpdateBasicDetailsSaga,
  // watchUpdateCompanyDetailsSaga,
  watchCreateOperatorSaga,
  watchGetTripsSaga,
  watchSettleTripSaga,
  watchCreateBankAccountSaga,
  watchEditBankAccountSaga,
  watchVerifyBankAccountOtpSaga,
  watchResendBankAccountOtpSaga,
  watchRevertOperatorDocumentSaga,
  watchVerifyRevertDocumentOtpSaga,
  watchResendRevertDocumentOtpSaga,
  watchDisableAccountSaga,
  watchSendToThirdPartySaga,
  watchDownloadLedgerSaga,
  watchGetFileUploadSaga,
  watchGetTdsFileUploadSaga,
  watchUpdateDocuments,
  watchGetFileViewSaga,
  watchViewTdsFileSaga,
  watchGetVehiclesListSaga,
  watchGetBankAccountSaga,
  watchGetOperatorSearch,
  watchOperatorStatusSaga,
  watchOperatorTypeSaga,
  // watchAddTdsDeclarationSaga,
  // watchEditTdsDeclarationSaga,
  watchGetLanesOptionsSaga,
  watchEditOnboardingDetailsSaga,
  watchCreateOperatorVehicleSaga,
  watchGetRcLinkSaga,
  watchSaveRcLinkSaga,
  watchGetODVTListSaga,
  watchGetKycStatusRemarksSaga,
  watchUpdateODVTSaga,
  watchDeleteODVTSaga,
  watchAddNewODVTSaga,
  watchGetVehicleInformationByVehicleNum,
  watchGetPhoneNoSaga,
} from '../components/Operator/store/sagas';

import {
  watchGetConsignerSuggestionsSaga,
  watchGetStartAddressesSaga,
  watchGetEndAddressesSaga,
  watchGetFormConfigSaga,
  watchCreateDemandSaga,
  watchAddAddressDemandSaga,
  watchGetViaPointsSuggestionsSaga,
} from '../components/CreateDemand/store/sagas';

import {
  watchGetConsignmentStatesSaga,
  watchfetchTripCancellationReasonSaga,
  watchCancelTripSaga,
  watchVerifyCancelTripOtpSaga,
  watchResendCancelTripOtpSaga,
  watchGetConsignmentsSaga,
  watchGetSupplyDetailsSaga,
  watchGetBasicDetailsSaga,
  watchGetOperatorByPhoneSaga,
  watchUpdateBasicDetailSaga,
  watchEditVehicleDetailsSaga,
  watchEditDriverDetailsSaga,
  watchCreateTransactionSaga,
  watchGetDemandDetailsSaga,
  watchGetThirdPartyDetailsSaga,
  watchGetActivityDetailsSaga,
  watchGetCommentCategoriesSaga,
  watchPostCommentSaga,
  watchGetDemandConfigSaga,
  watchGetRcConfig,
  watchUpdateDemandDetailsSaga,
  watchUpdateFreightDetailsSaga,
  watchUpdateOperatorFreightDetailsSaga,
  watchGetBankDetailsSaga,
  watchEditTransactionSaga,
  watchGetDocketsSaga,
  watchGetInvoicesSaga,
  watchGetInsuranceSaga,
  watchGetPodAuditSaga,
  watchSettleOperatorSaga,
  watchTdsRecalculateSaga,
  watchSaveBasicDetailsSaga,
  watchAddExpenseSaga,
  watchVerifyExpenseOtpSaga,
  watchResendExpenseOtpSaga,
  watchGetRcUrlSaga,
  watchGetRelationDocUrlSaga,
  watchGetInvoiceDocUrlSaga,
  watchGetInsuranceDocUrlSaga,
  watchSaveRcUrlSaga,
  watchCreateDocketSaga,
  watchsharePaymentLink,
  watchEditDocketSaga,
  watchGetCurrentDocketSaga,
  watchCreateInvoiceSaga,
  watchUploadFilesDocketSaga,
  watchViewFilesDocketSaga,
  watchViewInvoiceSaga,
  watchViewInsuranceSaga,
  watchGetTripDetailsSaga,
  watchGetAddressDetailsSaga,
  watchEditEndPointSaga,
  watchEditStartPointSaga,
  watchTriggerConsignerForBilti,
  watchGetViaPointsSaga,
  watchCreateViaPointSaga,
  watchGetExpenseTypesSaga,
  watchGetOperationSearchSaga,
  watchGetConsignerCodesSaga,
  watchSaveRcDetailsSaga,
  watchSaveInvoiceSaga,
  watchSaveInsuranceSaga,
  watchUpdateLocationSaga,
  watchUpdateStoppageReason,
  watchUpdateVehicleStateSaga,
  watchEditViaPointSaga,
  watchUploadFreightSaga,
  watchUpdateTimeSaga,
  watchGetRemarksSaga,
  watchGetTdsInfoSaga,
  watchGetConsignerTdsInfoSaga,
  watchViewFreightSaga,
  watchEditInvoiceSaga,
  watchSettleShipperSaga,
  watchEditExpenseSaga,
  watchDeleteExpenseSaga,
  watchViewRcValidationSaga,
  watchDeleteDocketSaga,
  watchEditInvoiceDetailsSaga,
  watchDeleteInvoiceSaga,
  watchGetEmailsListSagaOp,
  watchSavePodStatus,
  watchGetPodDetailsSaga,
  watchGetPodHistorySaga,
  watchSubmitPodDetails,
  watchUploadPodDocumentSaga,
  watchViewPodDocumentSaga,
  watchGetPodValidityRemarkSaga,
  // watchSubmitPodFileDetails,
  watchAddressDetailsOperationSagaV4,
  watchGetStatesDocketSaga,
  watchGetTripMapDetailsSaga,
  watchGetTripItinerarySaga,
  watchGetDelayReasonsSaga,
  watchGetCancelReasonsSaga,
  watchSubmitCancelReasonSaga,
  watchSubmitDelayReasonSaga,
  watchExtraExpensePolicySaga,
  watchGetExpenseTypesV3Saga,
  watchGetImageUrlSaga,
  watchUpdateReferenceIdSaga,
  watchgetPaymentBillingDataSaga,
  watchSubmitPaymentBillingSaga,
  watchSubmitDocketImages,
  watchGetImageProofDocketDetails,
  watchSubmitDelayModal,
  watchGetDelayModalData,
  watchGenerateEwayBillNumber,
  watchGetChatSessionSaga,
  watchGetChatMessagesSaga,
} from '../components/Operations/store/sagas';

import {
  watchGetIndentsListSaga,
  watchGetEmailsListSaga,
  watchGetDistrictListSaga,
  watchAssignIndentSaga,
  watchGetHeaderDetailsSaga,
  watchViewFreightApprovalSaga,
  watchFetchExpireReasons,
} from '../pages/Placement/store/sagas';

import {
  watchGetIndentsListSagaT,
  watchGetEmailsListSagaTicket,
  watchGetBasicDetailsSagaTicket,
  watchGetTicketingEntities,
  watchPostTicketingFields,
  watchViewUploadedDocumentSaga2,
  watchUploadFileDocumentSaga,
} from '../pages/ticketing/store/sagas';

import { watchCreateBulkDemandPTLSaga } from '../components/CreateDemandPTL/store/sagas';
import { watchPTLBulkMISSaga, watchPTLBulkMISTransportersSaga } from '../components/PTLBulkMIS/store/sagas';
import { watchGetUploadTypesSaga, watchUploadBulkFileSaga } from '../pages/bulkUpload/store/sagas';
import { watchPTLFreightUploadSaga } from '../components/PTLFreightUpload/store/sagas';
import { watchGetLaneRateListSaga } from '../components/LaneRateDashboard/store/sagas';
import ticketAssignmentSaga from '../pages/TicketAssignment/store/sagas';

import // watchGetDemandDetailsSaga,
// watchGetUserDetailsSaga,
// watchGetTransactionsSaga,
// watchGetDemandConfigSaga,
'../pages/Placement/DemandDetailsMaster/store/sagas';

import { showToaster } from 'components/Toaster/action';
import get from 'lodash/get';

export default function* () {
  yield all([
    fork(watchGetConsignersSaga),
    fork(watchFetchConsignerDetailsSaga),
    fork(watchCreateConsignerSaga),
    fork(watchEditBasicDetailsSaga),
    fork(watchEditVpaDetailsSaga),
    fork(watchCreateVpaDetailsSaga),
    fork(watchSaveEditedAddressSaga),
    fork(watchCreateNewAddressSaga),
    fork(watchSaveConsignerGstSaga),
    fork(watchCreateConsignerGstSaga),
    fork(watchDeletePocSaga),
    fork(watchDeleteAddressSaga),
    fork(watchDeleteGstSaga),
    fork(watchUploadDocumentSaga),
    fork(watchViewFileSaga),
    fork(watchGetUploadGstUrl),
    fork(watchViewGstUrlSaga),
    fork(watchGetThirdPartyListSaga),
    fork(watchCreateAccountSaga),
    fork(watchEditAccountSaga),
    fork(watchVerifyThirdPartyAccountOtpSaga),
    fork(watchResendThirdPartyAccountOtpSaga),
    fork(watchDisableEditSaga),
    fork(watchGetFormConfigSaga),
    fork(watchGetConsignerSuggestionsSaga),
    fork(watchGetStartAddressesSaga),
    fork(watchGetEndAddressesSaga),
    fork(watchCreateDemandSaga),
    fork(watchAddAddressDemandSaga),
    fork(watchGetOperatorsListSaga),
    fork(watchGetOperatorByIdSaga),
    fork(watchGetKycStatusHistorySaga),
    fork(watchGetBasicDetailsOperatorSaga),
    fork(watchViewUploadedDocumentSaga),
    fork(watchViewUploadedDocumentSaga2),
    fork(watchGetImageUrlSaga1),
    fork(watchGetImageUrlSaga),
    fork(watchUpdateReferenceIdSaga),
    fork(watchgetPaymentBillingDataSaga),
    fork(watchSubmitPaymentBillingSaga),

    fork(watchUpdateOperatorBasicDetailsSaga),
    fork(watchUpdateOperatorAddressDetailsSaga),
    fork(watchUpdateOperatorComplaincesDetailsSaga),
    fork(watchUpdateOperatorVehiclesDetailsSaga),
    fork(watchUpdateOperatorDocumentDetailsSaga),
    fork(watchUploadOperatorIdentityDocumentSaga),
    fork(watchUpdateOperatorTdsDetailsSaga),
    fork(watchUpdateBasicDetailsSaga),
    // fork(watchUpdateCompanyDetailsSaga),
    fork(watchCreateOperatorSaga),
    fork(watchGetTripsSaga),
    fork(watchSettleTripSaga),
    fork(watchCreateBankAccountSaga),
    fork(watchEditBankAccountSaga),
    fork(watchVerifyBankAccountOtpSaga),
    fork(watchResendBankAccountOtpSaga),
    fork(watchRevertOperatorDocumentSaga),
    fork(watchVerifyRevertDocumentOtpSaga),
    fork(watchResendRevertDocumentOtpSaga),
    fork(watchDisableAccountSaga),
    fork(watchSendToThirdPartySaga),
    fork(watchDownloadLedgerSaga),
    fork(watchGetFileUploadSaga),
    fork(watchGetTdsFileUploadSaga),
    // fork(watchAddTdsDeclarationSaga),
    // fork(watchEditTdsDeclarationSaga),
    fork(watchGetLanesOptionsSaga),
    fork(watchEditOnboardingDetailsSaga),
    fork(watchUpdateDocuments),
    fork(watchGetFileViewSaga),
    fork(watchViewTdsFileSaga),
    fork(watchGetConsignerTypeSaga),
    fork(watchGetConsignerStatusSaga),
    fork(watchEditCompliancesSaga),
    fork(watchUploadConsignerFileSaga),
    fork(watchViewConsignerFileSaga),
    fork(watchGetVpaDetailsSaga),
    fork(watchGetSearchResultsSaga),
    fork(watchGetBankAccountSaga),
    fork(watchGetOperatorSearch),
    fork(watchOperatorStatusSaga),
    fork(watchOperatorTypeSaga),
    fork(watchGetConsignmentStatesSaga),
    fork(watchfetchTripCancellationReasonSaga),
    fork(watchCancelTripSaga),
    fork(watchVerifyCancelTripOtpSaga),
    fork(watchResendCancelTripOtpSaga),
    fork(watchGetConsignmentsSaga),
    fork(watchGetSupplyDetailsSaga),
    fork(watchGetThirdPartyDetailsSaga),
    fork(watchGetActivityDetailsSaga),
    fork(watchGetCommentCategoriesSaga),
    fork(watchPostCommentSaga),
    fork(watchGetBasicDetailsSaga),
    fork(watchGetAddressDetailsOperatorSaga),
    fork(watchGetCompliancesDetailsOperatorSaga),
    fork(watchGetDocumentDetailsOperatorSaga),
    fork(watchGetVehicleDetailsOperatorSaga),
    // fork(watchGetOperatorDocumentViewUrlSaga),
    fork(watchSendUndertakingLinkSaga),
    fork(watchSendTdsLinkSaga),
    fork(watchGetPhoneNoSaga),
    fork(watchGetOperatorByPhoneSaga),
    fork(watchUpdateBasicDetailSaga),
    fork(watchEditVehicleDetailsSaga),
    fork(watchEditDriverDetailsSaga),
    fork(watchCreateTransactionSaga),
    fork(watchGetDemandDetailsSaga),
    fork(watchGetDemandConfigSaga),
    fork(watchGetRcConfig),
    fork(watchUpdateDemandDetailsSaga),
    fork(watchUpdateFreightDetailsSaga),
    fork(watchUpdateOperatorFreightDetailsSaga),
    fork(watchGetBankDetailsSaga),
    fork(watchEditTransactionSaga),
    fork(watchGetDocketsSaga),
    fork(watchGetInvoicesSaga),
    fork(watchGetInsuranceSaga),
    fork(watchGetPodAuditSaga),
    fork(watchSettleOperatorSaga),
    fork(watchTdsRecalculateSaga),
    fork(watchSaveBasicDetailsSaga),
    fork(watchAddExpenseSaga),
    fork(watchVerifyExpenseOtpSaga),
    fork(watchResendExpenseOtpSaga),
    fork(watchGetRcUrlSaga),
    fork(watchGetRelationDocUrlSaga),
    fork(watchGetInvoiceDocUrlSaga),
    fork(watchGetInsuranceDocUrlSaga),
    fork(watchSaveRcUrlSaga),
    fork(watchCreateDocketSaga),
    fork(watchsharePaymentLink),
    fork(watchEditDocketSaga),
    fork(watchGetCurrentDocketSaga),
    fork(watchCreateInvoiceSaga),
    fork(watchUploadFilesDocketSaga),
    fork(watchViewFilesDocketSaga),
    fork(watchViewInvoiceSaga),
    fork(watchViewInsuranceSaga),
    fork(watchGetTripDetailsSaga),
    fork(watchDeleteExpenseSaga),
    fork(watchViewRcValidationSaga),
    fork(watchGetAddressDetailsSaga),
    fork(watchEditEndPointSaga),
    fork(watchEditStartPointSaga),
    fork(watchTriggerConsignerForBilti),
    fork(watchGetViaPointsSaga),
    fork(watchCreateViaPointSaga),
    fork(watchGetExpenseTypesSaga),
    fork(watchGetOperationSearchSaga),
    fork(watchGetConsignerCodesSaga),
    fork(watchSaveRcDetailsSaga),
    fork(watchSaveInvoiceSaga),
    fork(watchSavePodStatus),
    fork(watchSaveInsuranceSaga),
    fork(watchUpdateLocationSaga),
    fork(watchUpdateStoppageReason),
    fork(watchUpdateVehicleStateSaga),
    fork(watchEditViaPointSaga),
    fork(watchUploadFreightSaga),
    fork(watchUpdateTimeSaga),
    fork(watchGetRemarksSaga),
    fork(watchGetTdsInfoSaga),
    fork(watchGetConsignerTdsInfoSaga),
    fork(watchViewFreightSaga),
    fork(watchEditInvoiceSaga),
    fork(watchSettleShipperSaga),
    fork(watchGetViaPointsSuggestionsSaga),
    fork(watchEditExpenseSaga),
    fork(watchGetIndentsListSaga),
    fork(watchGetEmailsListSaga),
    fork(watchGetDistrictListSaga),
    fork(watchGetEmailsListSagaOp),

    fork(watchAssignIndentSaga),
    fork(watchGetHeaderDetailsSaga),
    fork(watchViewFreightApprovalSaga),
    fork(watchFetchExpireReasons),
    fork(watchDeleteDocketSaga),
    fork(watchEditInvoiceDetailsSaga),
    fork(watchDeleteInvoiceSaga),
    fork(watchEditPaymentSaga),
    fork(watchEditBusinesstSaga),
    fork(watchEditNotificationSaga),
    fork(watchGetVehiclesListSaga),
    fork(watchCreateOperatorVehicleSaga),
    fork(watchGetRcLinkSaga),
    fork(watchSaveRcLinkSaga),

    fork(watchGetIndentsListSagaT),
    fork(watchGetEmailsListSagaTicket),
    fork(watchGetBasicDetailsSagaTicket),
    fork(watchGetTicketingEntities),
    fork(watchPostTicketingFields),
    fork(watchGetPodDetailsSaga),
    fork(watchGetPodHistorySaga),

    fork(watchSubmitPodDetails),
    fork(watchUploadPodDocumentSaga),
    fork(watchViewPodDocumentSaga),
    fork(watchGetODVTListSaga),
    fork(watchGetKycStatusRemarksSaga),
    fork(watchUpdateODVTSaga),
    fork(watchDeleteODVTSaga),
    fork(watchAddNewODVTSaga),
    fork(watchGetVehicleInformationByVehicleNum),
    fork(watchGetPodValidityRemarkSaga),
    fork(watchAddressDetailsOperationSagaV4),
    // fork(watchSubmitPodFileDetails),
    // fork(watchGetUserDetailsSaga),
    // fork(watchGetTransactionsSaga),
    fork(watchGetStatesDocketSaga),
    fork(watchGetTripMapDetailsSaga),
    fork(watchGetTripItinerarySaga),
    fork(watchGetDelayReasonsSaga),
    fork(watchGetCancelReasonsSaga),
    fork(watchSubmitCancelReasonSaga),
    fork(watchSubmitDelayReasonSaga),
    fork(watchExtraExpensePolicySaga),
    fork(watchGetExpenseTypesV3Saga),
    fork(watchUploadFileDocumentSaga),
    fork(watchCreateBulkDemandPTLSaga),
    fork(watchPTLBulkMISSaga),
    fork(watchGetLaneRateListSaga),
    fork(watchPTLBulkMISTransportersSaga),
    fork(watchPTLFreightUploadSaga),
    fork(watchGetUploadTypesSaga),
    fork(watchUploadBulkFileSaga),
    fork(watchSubmitDocketImages),
    fork(watchGetImageProofDocketDetails),
    fork(watchSubmitDelayModal),
    fork(watchGetDelayModalData),
    fork(watchGenerateEwayBillNumber),
    fork(watchGetChatSessionSaga),
    fork(watchGetChatMessagesSaga),
    fork(ticketAssignmentSaga),
  ]);
}

/*
 * entity must have a success, request and failure method
 * request is a function that returns a promise when called
 * */
export function* fetchEntity(request, entity, ...args) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(request);
    // we directly return the result object and throw away the headers and the status text here
    // if status and headers are needed, then instead of returning response.result, we have to return just response.
    if (response.data.success || (response.status >= 200 && response.status <= 300)) {
      yield put(entity.success(response.data.data || response.data, ...args));
    } else {
      yield put(entity.failure(response.data.message, ...args));
      yield put(showToaster({ toasterMsg: response.data.message, toasterType: 'error' }));
    }
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      Utils.reAuthenticate();
      return;
    }
    yield put(entity.failure(error && error.response && error.response.data ? error.response.data : {}, ...args));
    if (error?.response?.status === 400) {
      Sentry.captureException(error);
      yield put(
        showToaster({
          toasterMsg: error.response.data.message || 'Please provide complete details',
          toasterType: 'error',
        }),
      );
    } else if (error?.response?.status === 404) {
      yield put(
        showToaster({
          toasterMsg: error.response.data.error || error?.response?.status,
          toasterType: 'error',
        }),
      );
    } else if (error && error.response && error.response.status === 403) {
      yield put(showToaster({ toasterMsg: 'User does not have permissions', toasterType: 'error' }));
    } else {
      yield put(
        showToaster({
          toasterMsg: get(error, 'response.data.message') || 'Something went wrong!',
          toasterType: 'error',
        }),
      );
    }
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* fetchEntitySpawn(request, entity, ...args) {
  const { toaster, isFileUpload, isChainedRequest, chainedRequestData } = args[0] || {};

  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield request;
    if ((response && response.res && response.res.ok) || response.status === '200') {
      yield put(entity.success(response.resp, ...args));
      if (toaster) {
        yield put(showToaster({ toasterMsg: toaster.successMsg, toasterType: 'success' }));
      }
    }

    // 2xx with body: treat as success (avoid treating response.data.data as failure when API returns { data: {...} })
    const is2xx = !!response.status && response.status >= 200 && response.status < 300;
    const explicitFailure = response.data && response.data.success === false;
    const shouldDispatchSuccess =
      (response.data && response.data.success === true) || (is2xx && response.data && !explicitFailure);

    if (shouldDispatchSuccess) {
      if (isChainedRequest) {
        yield put(entity.success({ response: response.data, chainedRequestData: chainedRequestData }, ...args));
      } else {
        yield put(entity.success(response.data, ...args));
      }
      if (toaster) {
        yield put(showToaster({ toasterMsg: toaster.successMsg || response.data.message, toasterType: 'success' }));
      }
    } else {
      if (explicitFailure || (!is2xx && get(response, 'data.data'))) {
        yield put(entity.failure(response.data?.data ?? response.data, ...args));
        yield put(showToaster({ toasterMsg: toaster?.errorMsg || response.data?.message, toasterType: 'error' }));
      } else if (!is2xx) {
        const message = response?.data?.message ?? response?.message ?? 'Something went wrong';
        yield put(entity.failure(response?.data?.message ?? response?.data, ...args));
        yield put(showToaster({ toasterMsg: toaster?.errorMsg || message, toasterType: 'error' }));
      }

      if (!!response.status && response.status === 200 && response.data && response.data.errorCode == 400) {
        yield put(showToaster({ toasterMsg: response.data.message, toasterType: 'error' }));
      }
    }
  } catch (error) {
    if (error && error.response && error.response.status === 403) {
      yield put(showToaster({ toasterMsg: 'User does not have permission', toasterType: 'error' }));
      return;
    }
    if (error && error.response && error.response.status === 401) {
      Utils.reAuthenticate();
      return;
    }
    if (!isFileUpload) {
      // const message = error.response?.data?.message ?? error.response?.message ?? 'Something went wrong';
      const message =
        error.response?.data?.message ??
        error.response?.message ??
        (toaster ? toaster.errorMsg : 'Something went wrong');
      console.warn(error);
      yield put(entity.failure(error.response && error.response.data, ...args));
      yield put(showToaster({ toasterMsg: message, toasterType: 'error' }));
      Sentry.captureException(error);
    }
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function ignoreErrors(fn, ...args) {
  return () => {
    const ignoreErrorCallback = (response) => response;
    return fn(...args).then(ignoreErrorCallback, ignoreErrorCallback);
  };
}
